module.exports = __webpack_public_path__ + "img/laptop-globe.0510da1f.svg";